import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // {
    //     path: '/',
    //     redirect: '/v2'
    // },
    {
      path: "/*",
      component: () => import("./v3/ui/GamePage.vue"),
    },
  ],
});

export default router;
